export default __webpack_public_path__ + "static/media/facebook.a96e6ff3.svg";